export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const ADMIN_USERNAME = "admin";
export const ADMIN_PASSWORD = "1234";

export const staticPhoneExtensions = [
  { value: "+91", label: "+91" },
  { value: "+1", label: "+1" },
  { value: "+44", label: "+44" },
  { value: "+61", label: "+61" },
  { value: "+81", label: "+81" },
];

export const entitiesConfig = {
  serviceProviders: {
    name: "Service Provider",
    endpoints: {
      fetch: "/view_service_provider/v0.1",
      create: "/service_provider_reg/v0.1",
      update: "/service_provider_update/v0.1",
    },
    formFields: [
      { name: "service_provider_name", label: "Name", type: "text" },
      { name: "vas_id", label: "VAS", type: "select", dropdownKey: "vas" },
      { name: "shop_id", label: "Shop", type: "select", dropdownKey: "shop" },
      {
        name: "status_id",
        label: "Status",
        type: "select",
        dropdownKey: "status",
      },

      {
        name: "phone_extension",
        label: "Phone Extension",
        type: "select",
        dropdownKey: "phone_ext",
      },

      {
        name: "phone_no",
        label: "Phone No",
        type: "text",
        errorKey: "phone_no",
      },
      {
        name: "domain_id",
        label: "Domain",
        type: "select",
        dropdownKey: "domain",
      },
      { name: "worktime_from", label: "Work Time From", type: "time" },
      { name: "worktime_to", label: "Work Time To", type: "time" },
    ],
    columns: [
      { name: "service_provider_name", label: "Name" },
      { name: "vas_name", label: "VAS" },
      { name: "shop_name", label: "Shop" },
      { name: "status_name", label: "Status" },
      { name: "phone_extension", label: "Phone Extension" },
      { name: "phone_no", label: "Phone No" },
      { name: "domain_name", label: "Domain" },
      { name: "worktime_from", label: "Work Time From" },
      { name: "worktime_to", label: "Work Time To" },
      { name: "workdays", label: "Work Days" },
    ],
    dropdowns: {
      vas: "/view_vas/v0.1",
      shop: "/shop_view/v0.1",
      status: "/view_status/v0.1",
      domain: "/view_domain/v0.1",
    },
  },

  merchants: {
    name: "Merchants",
    endpoints: {
      fetch: "/view_merchant/v1.0",
      create: "/register_merchant/v1.0",
      update: "/update_merchant/v1.0",
    },
    formFields: [
      { name: "name", label: "Name", type: "text" },
      {
        name: "csc_name",
        label: "CSC",
        type: "text",
        readOnly: true,
        defaultValue: "India", // Display name, not editable
      },
      { name: "description", label: "Description", type: "text" },
      {
        name: "phone_extension",
        label: "Phone Extension",
        type: "select",
        dropdownKey: "phone_extension",
      },
      {
        name: "primary_phone",
        label: "Phone Number",
        type: "text",
        errorKey: "primary_phone",
      },

      { name: "merchant_email", label: "Merchant Email", type: "email" },
    ],
    columns: [
      { name: "merchant_id", label: "ID" },
      { name: "name", label: "Name" },
      { name: "csc_name", label: "CSC" }, // Display name in table
      { name: "description", label: "Description" },
      { name: "phone_extension", label: "Phone Ext." },
      { name: "primary_phone", label: "Primary Phone" },
      { name: "merchant_email", label: "Email" },
      { name: "status_name", label: "Status" },
      // { name: "added_date", label: "Added Date" },
      // { name: "updated_date", label: "Updated Date" },
    ],
  },
  shops: {
    name: "Shops",
    endpoints: {
      fetch: "/view_shop/v1.0",
      create: "/register_shop/v1.0",
      update: "/update_shop/v1.0",
    },
    formFields: [
      { name: "shop_name", label: "Shop Name", type: "text" },
      {
        name: "merchant_id",
        label: "Merchant",
        type: "select",
        dropdownKey: "merchant",
        optionsEndpoint: "/view_merchant/v1.0",
        method: "POST",
        requestBody: { view_type: "view" },
      },
      { name: "workdays", label: "Workdays", type: "number" },
      { name: "worktime", label: "Worktime", type: "number" },
      {
        name: "domain_id",
        label: "Domain",
        type: "select",
        dropdownKey: "domain",
      },
    ],
    columns: [
      { name: "shop_id", label: "ID" },
      { name: "shop_name", label: "Shop Name" },
      { name: "merchant_name", label: "Merchant" },
      { name: "domain_name", label: "Domain" }, // Display domain name
      { name: "workdays", label: "Workdays" },
      { name: "worktime", label: "Worktime" },
      // { name: "added_date", label: "Added" },
      // { name: "updated_date", label: "Updated" },
      { name: "status_name", label: "Status" },
    ],
    dropdowns: {
      merchant: "/view_merchant/v1.0", // Merchant dropdown endpoint
      domain: "/view_domain/v0.1", // Domain dropdown endpoint
    },
  },

  systemUsers: {
    name: "System Users",
    endpoints: {
      fetch: "/view_user/v1.0",
      create: "/register_user/v1.0",
      update: "/update_user/v1.0",
    },
    formFields: [
      { name: "user_name", label: "Username", type: "text" },
      { name: "first_name", label: "First Name", type: "text" },
      { name: "last_name", label: "Last Name", type: "text" },
      { name: "user_email", label: "Email", type: "email" },
      { name: "user_password", label: "Password", type: "password" },
      {
        name: "user_contact",
        label: "Contact",
        type: "text",
        errorKey: "user_contact",
      },
      // { name: "password_modified_on", label: "Password Modified On", type: "text" },
      { name: "workdays", label: "Workdays", type: "number" },
      {
        name: "merchant_id",
        label: "Merchant",
        type: "select",
        dropdownKey: "merchant",
        optionsEndpoint: "/view_merchant/v1.0",
        method: "POST",
        requestBody: { view_type: "view" },
      },
      {
        name: "status_id",
        label: "Status",
        type: "select",
        dropdownKey: "status",
        optionsEndpoint: "/view_status/v0.1",
      },
      { name: "users_uid", label: "User  UID", type: "text" },
    ],
    columns: [
      { name: "users_id", label: "ID" },
      { name: "user_name", label: "Username" },
      { name: "first_name", label: "First Name" },
      { name: "last_name", label: "Last Name" },
      { name: "user_email", label: "Email" },
      { name: "user_contact", label: "Contact" },
      { name: "password_modified_on", label: "Pwd Modified On" },
      { name: "workdays", label: "Workdays" },
      { name: "merchant_name", label: "Merchant" },
      { name: "status_name", label: "Status" },
      { name: "users_uid", label: "User  UID" },
      // { name: "added_date", label: "Added" },
      // { name: "updated_date", label: "Updated" },
    ],
    dropdowns: {
      merchant: "/view_merchant/v1.0",
      status: "/view_status/v0.1",
    },
  },
  beacons: {
    name: "Beacon Master",
    endpoints: {
      fetch: "/view_beacon_master/v1.1",
      create: "/registration_beacon_master/v1.1",
      update: "/update_beacon_master/v1.1",
    },
    formFields: [
      { name: "bec_name", label: "Beacon Name", type: "text", required: true },
      {
        name: "bec_type_id",
        label: "Beacon Type",
        type: "select",
        dropdownKey: "beacon_type",
      },
    ],
    columns: [
      { name: "bec_id", label: "Beacon ID" },
      { name: "bec_name", label: "Beacon Name" },
      { name: "bec_type_name", label: "Beacon Type" },
      // { name: "added_date", label: "Added Date" },
      // { name: "updated_date", label: "Updated Date" },
    ],
    dropdowns: {
      beacon_type: "/view_beacon_type/v1.1",
    },
  },

  dashboard: {
    endpoints: {
      users: "/user_view/v0.1",
      shops: "/view_shop/v1.0",
      merchants: "/view_merchant/v1.0",
      serviceProviders: "/view_service_provider/v1.0",
      establishments: "/view_establishment/v1.1",
    },
  },

  locationSelector: {
    endpoints: {
      establishments: "/view_establishment/v1.1",
      campuses: "/view_campus/v1.1",
      buildings: "/view_building/v1.1",
      floors: "/view_floor/v1.1",
    },
  },
  navigationMapping: {
    saveEndpoint: "/navigation_mapping_registration/v0.1",
  },

  beaconTable: {
    saveEndpoint: "/registration_beacon_config/v1.1",
    fetchWayternId: "/fetch_waytern_id/v0.1",
    viewBuilding: "/view_building/v1.1",
  },

  // other entities...
};

export const DRAG_THRESHOLD = 5; // Pixels
export const TRIPLE_CLICK_TIMEOUT = 750; // ms

export const DEFAULT_IMAGE_DIMENSIONS = {
  maxWidth: 610,
};

export const DEFAULT_MARKER = {
  type: "",
  connections: [],
  potentialConnections: [],
  status_id: 1,
  wayter_id: "1",
};

export const FILE_SIZE_LIMIT_KB = 500;
